import React, { useState } from "react";
import ChrLink from "../../Utils/ChrLink";
import { managementReportV2EventTracker } from "../../../specific/Reports/utils";

/*
props = {
  recommendationContent: <string>,
  link: <string>,
  linkText: <string>,
  eventCategory: <string>,
  closeAction: {
    setActivityInCacheUrl: <string>,
    activityCacheKey: <string>
  }
}
*/

const ChrDashboardRecommendation = (props) => {
  // TODO_ADMIN_DASHBOARD_RECOMMENDATIONS: move to specific folder
  const {
    recommendationContent,
    link,
    linkText,
    eventName,
    eventSource,
    recommendationImageUrl,
    closeAction
  } = props;

  // Image is used purely for decorative purpose. Hence aria-hidden is set as true
  const imageProps = { width: "25", height: "25", 'aria-hidden': true }

  const onViewRecommendationsButtonClick = () => managementReportV2EventTracker(eventName, { source: eventSource });
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    if (closeAction && closeAction.setActivityInCacheUrl && closeAction.activityCacheKey) {
      ClientActivitiesTrackerCache.setActivityInCache(
        closeAction.setActivityInCacheUrl,
        closeAction.activityCacheKey
      );
    }
    setIsVisible(false);
  };

  return (
    <>
      {
        (isVisible) && (
          <div className="m-b-md">
            <div className="d-flex align-items-center white-bg border-radius-0-5-important cui-border-gray p-3">
              <img src={recommendationImageUrl} {...imageProps} />
              <div className="px-2 font-14 font-bold">{recommendationContent}</div>
              <ChrLink href={link} onClick={onViewRecommendationsButtonClick} className="btn btn-primary btn-sm btn-rounded-5 ml-auto" newTab>{linkText}</ChrLink>
              {
                (closeAction) && (
                  <ChrLink noHref={true} onClick={handleClose} className="px-2 ml-3 font-16 text-muted">
                    <i className="fa-regular fa-times"></i>
                  </ChrLink>
                )
              }
            </div>
          </div>
        )
      }
    </>
  );
};

export default ChrDashboardRecommendation;
